import * as React from 'react';

import cn from 'classnames';

import { VariantDisplayType } from '@notino/shared/definitions/types';

import ErrorBoundary from '@components/ErrorBoundary';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { typographyClass } from '@styles/common';

import { TagDiscount } from '../VariantsInSelectBox/TagDiscount';

import { PriceDisplay } from './PriceDisplay';
import { Container, FlexWrapper, Name, Line, LineWrapper } from './styled';
import { usePriceLabelState } from './usePriceLabelState';

export interface ISelectedVariantProps {
  displayType: VariantDisplayType;
  singleVariant?: boolean;
  renderTagDiscount: boolean;
  variantName: React.ReactNode;
  hideLine?: boolean;
  hideVariantName?: boolean;
}

export const SelectedVariant: React.FC<ISelectedVariantProps> = React.memo(
  ({
    renderTagDiscount,
    variantName,
    hideLine = false,
    hideVariantName = false,
  }) => {
    const priceState = usePriceLabelState();
    const { currentVariant } = useProductDetailContext();
    const isSmall = priceState === 'default';

    return (
      <ErrorBoundary>
        <Container id="pdSelectedVariant">
          {renderTagDiscount && <TagDiscount variant={currentVariant} />}

          <FlexWrapper aria-live="assertive" tabIndex={0}>
            <Name
              className={cn({
                [typographyClass.labelRegular400]: isSmall,
                [typographyClass.labelLarge400]: !isSmall,
              })}
            >
              {hideVariantName ? null : variantName}
            </Name>

            <PriceDisplay variant={currentVariant} />
          </FlexWrapper>
          {!hideLine && (
            <LineWrapper>
              <Line />
            </LineWrapper>
          )}
        </Container>
      </ErrorBoundary>
    );
  }
);

SelectedVariant.displayName = 'SelectedVariant';
